// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@material-ui/core';
import { CloseIcon, WarningIcon } from 'sharedComponents/Icons';

const SharedLookLimitButton = ({ classes, handleCloseLimitButton }) => {
  return (
    <Box
      data-testid="shared-look-limit-btn"
      display="flex"
      alignItems="center"
      className={classes.SharedLookLimitButtonWrapper}
    >
      <WarningIcon className={classes.whiteColor} />
      <span className={classes.itemLink}>
        You have chosen the maximum number of products to create a Look. (10 products maximum)
      </span>
      <IconButton data-testid="close-plp-limit-notification-btn" onClick={handleCloseLimitButton}>
        <CloseIcon className={classes.whiteColor} />
      </IconButton>
    </Box>
  );
};

SharedLookLimitButton.defaultProps = {
  classes: {},
  handleCloseLimitButton: () => {},
};

SharedLookLimitButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  handleCloseLimitButton: PropTypes.func,
};

export default SharedLookLimitButton;
